



















































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ViewpointApi, VIEWPOINT_API } from "@/api/ViewpointApi";
import BasicInputForm from "@/components/forms/BasicInputForm.vue";
import ListInput from "@/components/forms/ListInput.vue";
import SupportWindow from "@/components/common/SupportWindow.vue";
//@ts-ignore
import { NotificationEventBus } from "@/EventBus";
import Sticky from 'vue-sticky-directive';
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditor.vue";
import Users from "@/store/modules/Users";
import Modelling from "@/store/modules/Modelling";
import Navigation from "@/store/modules/Navigation";
import Viewpoints from "@/store/modules/Viewpoints"
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import Apps from "@/store/modules/Apps"
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import { Urls } from "@/Urls";
import ViewpointNavigation from "@/components/navigation/ViewpointNavigation.vue";
import FactorNavigationWorkingModel from "@/components/navigation/FactorNavigationWorkingModel.vue";
import FactorNavigationPublishedModel from "@/components/navigation/FactorNavigationPublishedModel.vue";
import ChoiceNavigation from "@/components/navigation/ChoiceNavigation.vue";
import ScoringKeys, { ScoringKeyDefinition } from "@/store/modules/ScoringKeys";
import ChoiceVisibilitySelectorMenu from "@/components/workspace-options/ChoicesVisibilitySelectorMenu.vue";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import DecisionShareDialog from "@/components/decisions/DecisionManageUsersDialog.vue";
import CommentThreadDisplay from "@/components/comments/CommentThreadDisplay.vue";
import CommentThreadPanel from "@/components/comments/CommentThreadPanel.vue";
import ResourceEditingPanel from "@/components/panel/ResourceEditingPanel.vue";
import FactorScoringDefinitionCreatorVuexDialog
    from "@/components/scoring-definition/FactorScoringDefinitionCreatorVuexDialog.vue";
import VuexDialogScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditorVuexDialog.vue";
import FactorContributionVisibilitySwitch from "@/components/workspace-options/FactorContributionVisibilitySwitch.vue";
import ChoiceInputShareDialog from "@/components/share/ChoiceInputShareDialog.vue";
import ChoiceScoreInputShareDialog from "@/components/share/ChoiceScoreInputShareDialog.vue";
import { Decision } from "@/api/model/Decision";
import { Viewpoint } from "@/api/model/Viewpoint";
import _ from "lodash";
import ModelScoringKeyButtonTrigger from "@/components/scoring-key/ModelScoringKeyButtonTrigger.vue";
import ViewpointFactorVisibilityEditorVuexDialog
    from "@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityEditorVuexDialog.vue";
import { set } from "vue/types/umd";
import AppNavTree from "@/components/apps/AppsNavTree.vue";
import { Auth } from "aws-amplify";
import DecisionSelector from '@/components/common/DecisionSelector.vue';
import AppsSelector from '@/components/apps/AppsSelector.vue';

const usersModule = getModule(Users);
const modellingModule = getModule(Modelling);
const navigationModule = getModule(Navigation);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);
/*

const formJson: any = {
    '1': {
        id: '1',
        name: 'AMS',
        description: 'Choice Compare description ...',
        url: '/app/score/compare?viewpointIds=d5c75597-93ef-41d7-81fd-3fd845ba5156&viewpointIds=719541cb-393b-4b43-9107-4e17b6857a5b&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=719541cb-393b-4b43-9107-4e17b6857a5b',
        viewpointId: '719541cb-393b-4b43-9107-4e17b6857a5b',
    },
    '2': {
        id: '2',
        name: 'Current Scientific',
        description: 'Compare choices description choices description.',
        url: '/app/score/compare?viewpointIds=d5c75597-93ef-41d7-81fd-3fd845ba5156&viewpointIds=da1d4dc9-0ab8-4adb-8756-df90bf6eaa01&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=da1d4dc9-0ab8-4adb-8756-df90bf6eaa01',
        viewpointId: 'da1d4dc9-0ab8-4adb-8756-df90bf6eaa01',
    },
    '3': {
        id: '3',
        name: 'Orange Force',
        description: 'Compare viewpoints description viewpoints description viewpoints description viewpoints description.',
        url: '/app/score/compare?viewpointIds=d5c75597-93ef-41d7-81fd-3fd845ba5156&viewpointIds=d36d32f3-304a-49e8-8198-6b9117e24795&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=d36d32f3-304a-49e8-8198-6b9117e24795',
        viewpointId: 'd36d32f3-304a-49e8-8198-6b9117e24795',
    },
    '4': {
        id: '4',
        name: 'Techsol',
        description: 'Splash Page Example.',
        url: '/app/score/compare?viewpointIds=d5c75597-93ef-41d7-81fd-3fd845ba5156&viewpointIds=42810931-aa16-4228-a1d9-b890631443f3&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=42810931-aa16-4228-a1d9-b890631443f3',
        viewpointId: '42810931-aa16-4228-a1d9-b890631443f3',
    },
    '5': {
        id: '5',
        name: 'Virtual Marine',
        description: 'Splash Page Example.',
        url: '/app/score/compare?viewpointIds=d5c75597-93ef-41d7-81fd-3fd845ba5156&viewpointIds=b8acefd8-499d-48c8-9595-26150c3a4ddd&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=b8acefd8-499d-48c8-9595-26150c3a4ddd',
        viewpointId: 'b8acefd8-499d-48c8-9595-26150c3a4ddd',
    },
    '6': {
        id: '6',
        name: 'Compare Viewpoints',
        description: 'Splash Page Example.',
        url: '/app/score/choice?viewpointIds=42810931-aa16-4228-a1d9-b890631443f3&viewpointIds=719541cb-393b-4b43-9107-4e17b6857a5b&viewpointIds=da1d4dc9-0ab8-4adb-8756-df90bf6eaa01&viewpointIds=d36d32f3-304a-49e8-8198-6b9117e24795&viewpointIds=b8acefd8-499d-48c8-9595-26150c3a4ddd&decisionId=7513e6fa-f63a-4573-84dd-5ab94c80639b&choiceId=1e641626-9683-4777-bfdc-755f21dbf701&activeViewpointId=b8acefd8-499d-48c8-9595-26150c3a4ddd',
        viewpointId: '',
    },
};
*/
@Component({
    components: {
        ViewpointFactorVisibilityEditorVuexDialog,
        ModelScoringKeyButtonTrigger,
        ChoiceScoreInputShareDialog,
        ChoiceInputShareDialog,
        FactorContributionVisibilitySwitch,
        VuexDialogScoringKeyEditor,
        FactorScoringDefinitionCreatorVuexDialog,
        ResourceEditingPanel,
        CommentThreadPanel,
        CommentThreadDisplay,
        ScoringKeyEditorDialog,
        ScoringKeyEditor,
        BasicForm: BasicInputForm,
        ListInput,
        SupportWindow,
        ConfirmationDialog,
        ViewpointNavigation,
        FactorNavigationWorkingModel,
        FactorNavigationPublishedModel,
        ChoiceNavigation,
        ChoiceVisibilitySelectorMenu,
        DecisionShareDialog,
        AppNavTree,
        DecisionSelector,
        AppsSelector
    },
    directives: {
        Sticky,
    },
})
export default class ViewpointAppEmbed extends Vue {

    @Prop({type: String, default: '1'})
    queryAppEmbedId!: string;

    @Prop({type: String, default: '1'})
    queryAppEmbedMenuId!: string;

    @Prop()
    queryActiveViewpointId!: string;

    @Prop()
    queryViewpointIds!: string[] | string;

    @Prop()
    queryDecisionId!: string;

    @Prop()
    queryChoiceId!: string;

    @Prop()
    queryShowNonContributing!: string;

    @Prop()
    queryVisibleChoices!: string[];

    @Prop()
    navDrawerProp!: boolean;

    @Prop()
    queryChoiceListIds!: string[];

    @Prop()
    queryActiveFactorId!: string;

    @Prop()
    queryFactorListIds!: string[];

    @Prop()
    queryViewpointListIds!: string[];

    @Prop()
    querySkipGroups!: string;

    @Prop()
    queryChoiceSort!: string;

    @Prop()
    queryViewpointSort!: string;

    @Prop()
    queryAutocomplete!: string;

    @Prop()
    queryEnd!: string;

    @Prop()
    queryOpenRight!: string;

    @Prop()
    queryOpenLeft!: string;

    @Prop()
    queryShowDesc!: string;
    
    @Prop()
    queryShowBars!: string;
    
    @Prop()
    queryShowIconScoring!: string

    @Prop()
    queryChoiceColumnWidth!: string;

    @Prop()
    queryViewpointColumnWidth!: string;

    @Prop()
    queryChoiceNumOfCols!: string;

    @Prop()
    queryTrimTopGroups!: string;

    @Prop()
    queryShowScores!: string;

    @Prop()
    queryShowKeys!: string;

    @Prop()
    queryShowNonListFactors!: string;

    @Prop()
    queryShowComments!: string;

    @Prop()
    queryChoiceFirstCol!: string;

    @Prop()
    queryShowCustomRange!: string;

    @Prop()
    queryViewpointFirstCol!: string;

    @Prop()
    queryRankChoiceCol!: string;

    @Prop()
    queryPinnedRight!: string;
    
    @Prop()
    queryPinnedLeft!: string;

    @Prop()
    queryPromote!: string;
    // NEW APP CODE

    @Prop()
    queryMbDraggable!: string;

    // private selectedApp = "";
    get apps(){
        return appsModule.appList;
    }

    get selectedApp(){
        console.log(appsModule.appId);
        // this.selectedApp = appsModule.appId;
        return appsModule.appId;
    }

    get appsDictionary(){
        return appsModule.appsDictionary;
    }

    // // Fills the APP dropdown
    // get allApps(): any[] {
    //     if (this.apps) {
    //         let res: any[] = [];
    //         this.apps.forEach( (app: any, i: number) => {
    //             res.push({id: i, name: app.name});
    //         });
    //         // console.log(res);
    //         return res;
    //     }
    // }

    get appMenuId() {
        return appsModule.activeAppMenuId;
    }

    get openLeft(){
        return workspaceOptionsModule.openLeft;
    }

    get openRight(){
        return workspaceOptionsModule.openRight;
    }

    set openLeft(open: boolean) {
        workspaceOptionsModule.setOpenLeft(open);
    }

    set openRight(open: boolean) {
        workspaceOptionsModule.setOpenRight(open);
    }

    set selectedApp(id:string){
        appsModule.setSelectedAppId(id);
    }

    @Watch('queryShowBars')
    private onChangeShowBars() {
        if (this.queryShowBars != null) {
            workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
        } else {
            workspaceOptionsModule.setScoreBarVisibility(false);
        }
    }

    @Watch('queryShowIconScoring')
    private onChangeIconScoring() {
        if (this.queryShowIconScoring != null) {
            workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
        } else {
            workspaceOptionsModule.changeIconScoring(false);
        }
    }

    @Watch('queryChoiceColumnWidth')
    private onChangeChoiceColumnWidth() {
        if (this.queryChoiceColumnWidth != null) {
            workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
        } else {
            workspaceOptionsModule.changeChoiceColumnWidth(150);
        }
    }

    @Watch('queryViewpointColumnWidth')
    private onChangeViewpointColumnWidth() {
        if (this.queryViewpointColumnWidth != null) {
            workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
        } else {
            workspaceOptionsModule.changeViewpointColumnWidth(150);
        }
    }

    @Watch('queryChoiceNumOfCols')
    private onChangeChoiceNumOfCols() {
        if (this.queryChoiceNumOfCols != null) {
            workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
        } else {
            workspaceOptionsModule.setNumOfCols(3);
        }
    }

    @Watch('queryActiveViewpointId')
    private setActiveViewpointId(){
        viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
    }

    @Watch('queryFactorListIds')
    private onChangeFactorList(){
        workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
            
    }

    @Watch('queryActiveFactorId')
    private onChangeActiveFactor(){
       workspaceOptionsModule.selectBreadcrumbItem(this.queryActiveFactorId);
            
    }

    @Watch('querySkipGroups')
    private onChangeSkipGroups(){
       workspaceOptionsModule.changeSkipGroups(this.querySkipGroups === 'true');           
    }

    @Watch('queryViewpointListIds')
    private onChangeViewpointList(){
        console.log(this.queryViewpointListIds)
        workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
 
    }

    @Watch('queryChoiceListIds')
    private onChangeChoiceList(){
        workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
    }

    @Watch('queryTrimTopGroups')
    private onChangeQueryTrimTopGroups(){
       workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');           
    }
    
    @Watch('queryShowDesc')
    private onChangeShowDesc(){
        if(this.queryShowDesc!= null){
            workspaceOptionsModule.setDescriptionVisibility(this.queryShowDesc === 'true');
        }else{
            workspaceOptionsModule.setDescriptionVisibility(false);
        }
    }

    @Watch('queryShowCustomRange')
    private onChangeCustomScoringRange(){
       workspaceOptionsModule.changeCustomRangeActive(this.queryShowCustomRange === 'true');           
    }

    @Watch('queryPinnedRight')
    private onChangePinnedRight(){
        workspaceOptionsModule.changePinnedRight(this.queryPinnedRight === 'true');           
    }

    @Watch('queryMbDraggable')
    private onChangeMbDraggable() {
        workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');
    }
    
    // Fills the left nav
    // get appMenu() {
    //     // console.log(this.allApps);
    //     if (!this.allApps.length) return [];
    //     let res: any[] = [];
    //     if (this.appsDictionary[this.selectedApp] && this.appsDictionary[this.selectedApp].hasOwnProperty('children')) {
    //         res = this.appsDictionary[this.selectedApp].children;
    //         // console.log(res);
    //         return res;
    //     } else {
    //         return [];
    //     }
    // }

    get appLabel(){
        return this.selectedApp ? "" : "Please create or select an App";
    }

    mounted() {
        if (this.$route.path === '/') {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.CHOICE_SUBMITTER) {
            this.navTabs = 1;
        } else {
            this.navTabs = 2;
        }

        /*
        if (this.$cookies.isKey("vp-form-width")) {
            this.sliderRight = this.$cookies.get("vp-form-width")
            this.sliderLeft = -1 * this.sliderRight;
        }
        */

        this.initialize();

        setTimeout(() => this.increment++, 2000);
        // setTimeout(() => this.increment++, 20000);

        this.sliderPageWidth = [this.sliderLeft, this.sliderRight];

        NotificationEventBus.getEventBus().$on('choice-updated', (choice: any) => {
            choicesModule.setChoice(choice)
        });
    }

 

    async initialize() {
        let res = await decisionsModule.fetchDecisions();
        // console.log('res = await decisionsModule.fetchDecisions()');
        // console.log(res);
        if (this.queryDecisionId) {

            /*
            if (this.queryAutocomplete && this.queryAutocomplete === 'viewpoint') {
                let unauthUser: any;
                let authUser = await Auth.currentUserInfo();
                let userId: string;
                if (authUser) {
                    userId = authUser.username;
                } else {
                    unauthUser = await Auth.currentCredentials();
                    userId = unauthUser.identityId;
                }
                // console.log('userId');
                // console.log(userId);
                await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId)
            }
            */
            // fetch apps information
            await decisionsModule.selectDecision(this.queryDecisionId);
            await appsModule.fetchAppsByDecision(this.queryDecisionId);

            if (this.queryEnd && this.queryEnd.length) {
                navigationModule.setRequiredEnd(this.queryEnd);
            }

            // console.log('initialize() > decisionsModule.selectedDecisionUsers');
            // console.log(JSON.stringify(decisionsModule.selectedDecisionUsers));

            if (this.queryViewpointIds && Array.isArray(this.queryViewpointIds) && this.queryViewpointIds.length) {
                this.queryViewpointIds.forEach(viewpointsModule.selectViewpoint);
            } else if (!Array.isArray(this.queryViewpointIds)) {
                viewpointsModule.selectViewpoint(this.queryViewpointIds);
            } else if (this.decisionViewpointsList.length > 0) {
                viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
            }

            if (this.queryActiveViewpointId) {
                viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
            }

            if (this.queryChoiceId) {
                choicesModule.selectChoice(this.queryChoiceId);
            } else if (choicesModule.choiceIds.length) {
                choicesModule.selectChoice(choicesModule.choiceIds[0]);
            }

            if (this.queryFactorListIds != null) {
                workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
            }

            if (this.queryViewpointListIds != null) {
                workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
            }

            if (this.queryChoiceListIds != null) {
                workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
            }

            if (this.queryChoiceSort != null) {
                workspaceOptionsModule.changeChoiceSort(parseInt(this.queryChoiceSort));
            }

            if (this.queryViewpointSort != null) {
                workspaceOptionsModule.changeViewpointSort(parseInt(this.queryViewpointSort));
            }

            if (this.queryVisibleChoices) {
                workspaceOptionsModule.showSetChoicesOnly(this.queryVisibleChoices);
            }
            // Remove with show 0 switch - keep in case of future features 
            // if (this.queryShowNonContributing != null) {
            //     workspaceOptionsModule.changeContributingFactorVisibility(this.queryShowNonContributing == 'true');
            // }

            if (this.queryShowBars != null) {
                workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
            } 

            if (this.queryOpenLeft != null) {
                workspaceOptionsModule.setOpenLeft(this.queryOpenLeft === 'true');
            }
            if (this.queryOpenRight != null) {
                workspaceOptionsModule.setOpenRight(this.queryOpenRight === 'true');
            }

            if (this.queryPinnedRight != null) {
                workspaceOptionsModule.setPinnedRight(this.queryPinnedRight === 'true');
            }

            if (this.querySkipGroups != null) {
                workspaceOptionsModule.changeSkipGroups(this.querySkipGroups === 'true');
            }

            if (this.queryTrimTopGroups != null) {
                workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');
            }

            if (this.queryShowScores != null) {
                workspaceOptionsModule.setScoresVisibility(this.queryShowScores === 'true');
            }

            if (this.queryShowKeys != null) {
                workspaceOptionsModule.setKeysVisibility(this.queryShowKeys === 'true');
            }

            if (this.queryShowNonListFactors != null) {
                workspaceOptionsModule.setShowNonListFactors(this.queryShowNonListFactors == 'true');
            }

            if (this.queryShowComments != null) {
                workspaceOptionsModule.setKeysVisibility(this.queryShowComments === 'true');
            }

            if (this.queryShowDesc != null) {
                workspaceOptionsModule.setDescriptionVisibility(this.queryShowDesc === 'true');
            }

            if (this.queryShowIconScoring != null) {
                workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
            }

            if (this.queryChoiceFirstCol != null) {
                workspaceOptionsModule.setChoiceFirstCol(Number(this.queryChoiceFirstCol));
            } else {
                workspaceOptionsModule.setChoiceFirstCol(600);
            }

            if (this.queryViewpointColumnWidth != null) {
                workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
            } else {
                workspaceOptionsModule.changeViewpointColumnWidth(200);
            }

            if (this.queryChoiceColumnWidth != null) {
                workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
            } else {
                workspaceOptionsModule.changeChoiceColumnWidth(200);
            }

            if (this.queryChoiceNumOfCols != null) {
                workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
            } else {
                workspaceOptionsModule.setNumOfCols(3);
            }

            if (this.queryRankChoiceCol != null) {
                workspaceOptionsModule.setRankChoiceCol(Number(this.queryRankChoiceCol));
            } else {
                workspaceOptionsModule.setRankChoiceCol(150);
            }
            
            if (this.queryShowCustomRange != null) {
                workspaceOptionsModule.changeCustomRangeActive(this.queryShowCustomRange === 'true');
            }

            if (this.queryViewpointFirstCol != null) {
                workspaceOptionsModule.setViewpointFirstCol(Number(this.queryViewpointFirstCol));
            } else {
                workspaceOptionsModule.setViewpointFirstCol(600);
            }

            if (this.queryPinnedLeft != null) {
                workspaceOptionsModule.setPinnedLeft(this.queryPinnedLeft === 'true');
            }
            // APPS TEST
            if (this.queryAppEmbedId != null){
                appsModule.setSelectedAppId(this.queryAppEmbedId);
            }

            if(this.queryAppEmbedMenuId != null){
                appsModule.selectAppMenuById(this.queryAppEmbedMenuId);
            }

            if (this.queryMbDraggable != null) {
                workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');
            }
        }

        this.initialLoad = false;

    }

    private readonly URLS = Urls;
    private initialLoad = true;
    private increment: number = 1;

    navDrawer: boolean = this.navDrawerProp;

    private loadingResources = false;
    private processing = false;

    private createDecisionDialog = false;
    private editDecisionDialog = false;
    private createViewpointDialog = false;

    private section: string = this.URLS.TEMPLATE_BUILDER;
    private fullPath: string = '';

    private staticPageWidth = [-50, 50];
    private sliderPageWidth: any[] = [];
    private sliderLeft: number = -50;
    private sliderRight: number = 50;

    private panelLeft: boolean = true;
    private navTabs: number = 0;
    private scoreTabs: string = '';

    private searchFactors: string | null = null;
    private decisionSelectorMenuShow: boolean = false;


    get isOwner(): boolean {
        return (this.userId != null) && (this.userId === this.decisionOwnerUserId);
    }

    get userId(): string | undefined {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return undefined;
    }

    get decisionOwnerUserId(): string | undefined {
        if (decisionsModule.selectedDecision) {
            return decisionsModule.selectedDecision.ownerUserId;
        }
    }

    get scoreItems() {
        let items = [
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_SUBMITTER_EMBED             , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_CARDS_EMBED                 , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: `${this.pluralViewpointLabel}`, tooltip: '', url: this.URLS.WEIGHTING_EMBED                 , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Compare Content', tooltip: '', url: this.URLS.CHOICE_SCORER_COMPARE_EMBED, section: this.URLS.WEIGHTING_EMBED},
            {text: `Compare ${this.pluralViewpointLabel}`, tooltip: '', url: this.URLS.CHOICE_SCORER_EMBED     , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Classify & Rank', tooltip: '', url: this.URLS.CHOICE_SCORER_BINS_EMBED   , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Results', tooltip: '', url: this.URLS.RESULTS_EMBED   , section: this.URLS.WEIGHTING_EMBED},

        ];

        let decisionUsers = decisionsModule.selectedDecisionUsers
        if (this.currentUserProfile && decisionUsers[this.currentUserProfile.userId]
            && ['OWNER', 'ADMIN'].includes(decisionUsers[this.currentUserProfile.userId].permissionAccess)) {
            items.splice(0, 0, {text: 'Model', tooltip: '', url: this.URLS.TEMPLATE_BUILDER_EMBED, section: this.URLS.TEMPLATE_BUILDER_EMBED})
            if (this.$route.path === this.URLS.TEMPLATE_BUILDER_EMBED) {
                this.scoreTabs = this.URLS.TEMPLATE_BUILDER_EMBED;
            }
        }
        return items;
    }


    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get draftFactorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get selectedDraftFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }

    get selectedChoiceName() {
        return this.selectedChoice ? this.selectedChoice.name : '- select one -';
    }

    get selectedViewpointName() {
        if (this.viewpoints.hasOwnProperty(this.activeViewpointId)) {
            return this.viewpoints[this.activeViewpointId].name;
        }
        return '- select one -';
    }

    get selectedFactorName() {
        if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            if (this.selectedDraftFactorResourceItemId && this.draftFactorResources.hasOwnProperty(this.selectedDraftFactorResourceItemId)) {
                return this.draftFactorResources[this.selectedDraftFactorResourceItemId].name;
            }
        } else {
            if (this.selectedFactorResourceItemId && this.factorResources.hasOwnProperty(this.selectedFactorResourceItemId)) {
                return this.factorResources[this.selectedFactorResourceItemId].name;
            }
        }
        return '- select one -';
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || {};
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId || '';
    }

    set activeViewpointId(viewpointId: string) {
        if (viewpointId) {
            viewpointsModule.selectActiveViewpoint(viewpointId);
        }
    }

    private async selectActiveViewpoint(viewpointId: string | null = null) {
        if (viewpointId) {
            await this.selectViewpoint(viewpointId);
        }
        viewpointsModule.selectActiveViewpoint(viewpointId);
        console.log(viewpointId);
    }

    private async selectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointsModule.selectViewpoint(viewpointId);
        }
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    set scoreBarVisibility(visible: boolean) {
        workspaceOptionsModule.changeScoreBarVisibility(visible);
    }

    get currentUserProfile() {
        return usersModule.currentUserProfile;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    };

    set selectedViewpoints(selectedViewpoints: Viewpoint[] | undefined) {
        if (!selectedViewpoints) return;
        let chosenViewpointIds = selectedViewpoints.map(v => v.viewpointId);
        let viewpointsToAdd = _.pullAll(chosenViewpointIds, viewpointsModule.selectedViewpointIds);
        let viewpointsToRemove = _.pullAll(viewpointsModule.selectedViewpointIds, chosenViewpointIds);
        viewpointsToRemove.forEach(viewpointsModule.deselectViewpoint)
        viewpointsToAdd.forEach(viewpointsModule.selectViewpoint)
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    setSelectedDecision() {
        if (
            this.decisionViewpointsList &&
            this.decisionViewpointsList.length > 0
        ) {
            viewpointsModule.selectViewpoint(
                this.decisionViewpointsList[0].viewpointId
            );
            workspaceOptionsModule.resetViewpointColumnsWidth();

        }
        if (this.choicesList && this.choicesList.length) {
            choicesModule.selectChoice(this.choicesList[0].id);
            workspaceOptionsModule.resetChoiceColumnsWidth();
        }
        if (
            this.currentUserProfile &&
            this.selectedDecision &&
            this.currentUserProfile.userId !==
                this.selectedDecision.ownerUserId
        ) {
            if (this.$route.name !== 'ChoiceSubmitter') {
                this.$router.push({ name: 'ChoiceSubmitter' });
            }
            this.section = this.URLS.CHOICE_SUBMITTER;
        } else {
            if (this.$route.name !== 'DecisionBuilder') {
                this.$router.push({ name: 'DecisionBuilder' });
            }
            this.section = this.URLS.TEMPLATE_BUILDER;
        }
    }

    // kathy: this set function is no longer needed
    // set selectedDecision(decision: Decision | null) {
    //     if (decision) {
    //         decisionsModule.selectDecision(decision.decisionId)
    //             .then(() => {
    //                 if (this.decisionViewpointsList && this.decisionViewpointsList.length > 0) {
    //                     viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
    //                 }
    //                 if (this.choicesList && this.choicesList.length) {
    //                     choicesModule.selectChoice(this.choicesList[0].id)
    //                 }
    //                 appsModule.setSelectedAppId("");
    //                 appsModule.fetchAppsByDecision(decision.decisionId);
    //                 this.$router.push({name: ''});
                    // kathy - remove following reroute functions
                    // if (this.currentUserProfile && this.selectedDecision && this.currentUserProfile.userId !== this.selectedDecision.ownerUserId) {
                    //     if (this.$route.name !== 'ChoiceSubmitter') {
                    //         this.$router.push({name: 'ChoiceSubmitter'});
                    //     }
                    // } else {
                    //     if (this.$route.name !== 'DecisionBuilder') {
                    //         this.$router.push({name: 'DecisionBuilder'});
                    //     }
                    // }
    //             });
    //     }
    // }

    get panelRight() {
        return workspaceOptionsModule.rightPanelOpen;
    }

    set panelRight(value: boolean) {
        workspaceOptionsModule.setRightPanelOpen(value);
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    };

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice) {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    get decisionViewpointsList() {
        if (this.selectedDecision) {
            return decisionsModule.decisionViewpoints[this.selectedDecision.decisionId]
        }
        return [];
    }

    get decisions() {
        return _.sortBy(Object.values(decisionsModule.decisions), 'name');
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get loading() {
        return this.loadingResources
            || this.processing;
    }

    get pageWidth(): number {
        return this.sliderPageWidth[1] - this.sliderPageWidth[0];
    }

    get url() {
        return this.generateUrl();
    }

    get appActiveItem() {
        return appsModule.appsActiveItem;
    }
    
    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight
    }

    set pinnedRight(val: boolean) {
        workspaceOptionsModule.changePinnedRight(val)
    }


    @Watch('sliderLeft')
    sliderLeftChange(left: number) {
        if (left > -25) {
            left = -25;
        }
        this.sliderPageWidth[1] = -1 * (left);
        this.sliderRight = -1 * (left);
    }
    
    @Watch('queryChoiceId')
    private onChangeSelectedChoiceId () {
        choicesModule.setSelectedChoiceId(this.queryChoiceId);
    }

    @Watch('sliderRight')
    sliderRightChange(right: number) {
        if (right < 25) {
            right = 25;
        }
        this.sliderPageWidth[0] = -1 * (right);
        this.sliderLeft = -1 * (right);
        this.$cookies.set("vp-form-width", this.sliderRight);
    }

    @Watch('navDrawer')
    navDrawerChange(newVal: boolean) {
        if (!newVal) {
            this.$emit('nav-drawer-changed', false);
        }
    }

    @Watch('navDrawerProp')
    navDrawerPropChange(newVal: boolean) {
        this.navDrawer = newVal;
        this.panelLeft = !this.panelLeft;
    }

    @Watch('$route', {immediate: true, deep: true})
    onRouteChange() {
        this.generateUrl();
    }

    private generateUrl() {
        let urlPath = this.$router.currentRoute.path;
        let currentUrl: any = {
            path: urlPath,
            params: ''
        };
        let params: any = {
            viewpointIds: viewpointsModule.selectedViewpointIds,
            decisionId: decisionsModule.selectedDecisionId,
            choiceId: choicesModule.selectedChoiceId,
            activeViewpointId: viewpointsModule.activeViewpointId,
            appEmbedId: appsModule.selectedAppId,
            appEmbedMenuId: appsModule.activeAppMenuId,
            showNonContributing: workspaceOptionsModule.contributingFactorVisibility,
            // visibleChoices: Object.keys(workspaceOptionsModule.choiceVisibility).filter((k: string) => workspaceOptionsModule.choiceVisibility[k]),
            choiceListIds: workspaceOptionsModule.activeChoiceLists,
            factorListIds: workspaceOptionsModule.activeFactorLists,
            viewpointListIds: workspaceOptionsModule.activeViewpointLists,
            activeFactorId: workspaceOptionsModule.selectedPathItemId,
            showDesc: workspaceOptionsModule.descriptionVisibility.toString(),
            showBars: workspaceOptionsModule.scoreBarVisibility.toString(),
            showIconScoring: workspaceOptionsModule.showIconScoring,
            skipGroups: workspaceOptionsModule.skipGroups,
            showNonListFactors: workspaceOptionsModule.showNonListFactors,
            viewpointSort: workspaceOptionsModule.viewpointSort,
            choiceSort: workspaceOptionsModule.choiceSort,
            openLeft: workspaceOptionsModule.openLeft.toString(),
            openRight: workspaceOptionsModule.openRight,
            choiceColumnWidth: workspaceOptionsModule.choiceColumnWidth,
            viewpointColumnWidth: workspaceOptionsModule.viewpointColumnWidth,
            choiceNumOfCols: workspaceOptionsModule.numOfCols,
            trimTopGroups: workspaceOptionsModule.trimTopGroups,
            showScores: workspaceOptionsModule.scoresVisibility.toString(),
            showKeys: workspaceOptionsModule.keysVisibility.toString(),
            showComments: workspaceOptionsModule.commentsVisibility.toString(),
            choiceFirstCol: workspaceOptionsModule.choiceFirstCol,
            showCustomRange: workspaceOptionsModule.customRangeActive.toString(),
            viewpointFirstCol: workspaceOptionsModule.viewpointFirstCol,
            rankChoiceCol: workspaceOptionsModule.rankChoiceCol,
            pinnedRight: workspaceOptionsModule.pinnedRight,
            mbDraggable: workspaceOptionsModule.mbDraggable
        };
        let path = '';

        if (Object.values(params).filter(f => f).length > 0) {
            path = path + '?'
            for (let p in params) {
                if (params[p] && params[p] != null) {
                    if (Array.isArray(params[p]) && params[p].length > 0) {
                        path = path + (params[p] as any[]).map(v => p + '=' + v).join('&') + '&'
                    } else if (!Array.isArray(params[p])) {
                        path = path + p + '=' + params[p] + '&';
                    }
                }
            }
            path = path.substring(0, path.length - 1);
        }
        
        //@ts-ignore
        currentUrl.params = path;
        history.pushState({}, null, path);
        path = urlPath + path;
        this.fullPath = path;
        workspaceOptionsModule.setCurrentUrl(currentUrl);
        this.$emit('new-path', path);
        return path;
    }

    private recenterSlider(value: any[]) {
        if (value[0] > (-25)) {
            value[0] = -25;
            this.sliderPageWidth[0] = -25;
        }
        this.sliderLeft = value[0];
        if (value[1] < (25)) {
            value[1] = 25;
            this.sliderPageWidth[1] = 25;
        }
        this.sliderRight = value[1];
    }

    private async createViewpoint(viewpoint: any) {
        this.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            if (!this.selectedDecision) return;
            await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            })
            this.emitSuccessMessage();
        } catch (err) {
            this.emitFailedMessage(err)
        }
    }

    private async createDecision(decisionInput: any) {
        this.createDecisionDialog = false;
        this.emitProcessingMessage();
        let newDecision = await decisionsModule.createDecision({
            name: decisionInput.name,
            description: decisionInput.description
        });
        await decisionsModule.selectDecision(newDecision.decisionId)
        this.emitSuccessMessage();
    }

    private async deleteDecision(decisionId: string) {
        await decisionsModule.deleteDecision(decisionId)
    }

    private async editDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateDecision(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private emitProcessingMessage() {
        this.processing = true;
        NotificationEventBus.emitProcessingMessage()
    }

    private emitSuccessMessage() {
        this.processing = false;
        NotificationEventBus.emitSuccessMessage()
    }

    private emitFailedMessage(error: any) {
        this.processing = false;
        NotificationEventBus.emitFailedMessage(error);
    }

    private updateScoringKeyDefinition(scoringKeys: any[]) {
        let scoringKeyDefinition: ScoringKeyDefinition | null;
        if (scoringKeys == null || scoringKeys.length === 0) {
            scoringKeyDefinition = null;
        } else {
            scoringKeyDefinition = {
                scoringKeys: scoringKeys,
                notApplicableEnabled: false
            }
        }

        NotificationEventBus.emitProcessingMessage();
        scoringKeysModule.updateDecisionScoringKeyDefinition(scoringKeyDefinition)
            .then(() => {

            })
            .catch((error: any) => {
                NotificationEventBus.emitFailedMessage({message: error.message});
            });
    }


}
